module.exports = __webpack_public_path__ + "static/media/24UHCHR10.a17e2fe5.jpg";